module.exports = __webpack_public_path__ + "static/media/buy_req_make_13.82321269.jpg";